import { NextPageContext } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Article, { Roles } from 'models/Article';
import CmsPage from 'models/CmsPage';

import { LIST_MARKUP } from 'consts/redux';

import { list as listArticles } from 'requests/articles';
import { single as singleCmsPage } from 'requests/cmsPages';

import Component from './component';
import { Props } from './types';

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let articles: ListCollection<Article> = LIST_MARKUP;
    let cmsPage: CmsPage = null;

    try {
        await Promise.all([
            listArticles({
                page: 1,
                perPage: 12,
                role: Roles.Company,
            }),
            singleCmsPage({ slug: 'employerarticles' }),
        ]).then(responses => {
            articles = responses[0];
            cmsPage = responses[1];
        });
    } catch (error) {
        console.error(error);
    }

    return {
        articles: articles || null,
        cmsPage: cmsPage || null,
    };
};

export default Component;
